module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium.3b06a51f.eot";